import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=2b125ff1&scoped=true"
import script from "./Cashier.vue?vue&type=script&lang=js"
export * from "./Cashier.vue?vue&type=script&lang=js"
import style0 from "./Cashier.vue?vue&type=style&index=0&id=2b125ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b125ff1",
  null
  
)

export default component.exports